import { initializeDeveloperCopilot } from 'app/developer-v3/copilot/bootstrap';

initializeDeveloperCopilot();
